import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetRaterForm {
  search: string;
  year: string;
  userid?: string;
  page: number;
  size: number;
}

export const getRaterForm = ({
  search,
  year,
  page,
  size,
  userid
}: GetRaterForm) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.raterForm.getList
    }?search=${search}&tahun=${year}&page=${page}&userid=${userid || ''}    `
  );
};

export const getRaterFormDetail = (id: string) => {
  return HttpService.get(
    `${ApiService.icdc.module.raterForm.detail}?insertid=${id}`
  );
};

export const postRaterForm = (data) => {
  return HttpService.post(ApiService.icdc.module.raterForm.add, data);
};

export const updateRaterForm = (data) => {
  return HttpService.post(ApiService.icdc.module.raterForm.update, data);
};

export const editRaterForm = (data) => {
  return HttpService.post(ApiService.icdc.module.raterForm.update, data);
};

export const deleteRaterForm = (data) => {
  return HttpService.post(ApiService.icdc.module.raterForm.delete, data);
};

export const downloadRaterForm = (data) => {
  return HttpService.post(ApiService.icdc.module.raterForm.download, data);
};
